export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.20-0754.47",
  commitId: "6f803fbc68e4da7f00e20466f782d29f8da1087c",
  commitTime: "2026-07-20T07:54:47.000Z",
});
